import { render, staticRenderFns } from "./ChangePin.vue?vue&type=template&id=65e975d7&scoped=true&"
import script from "./ChangePin.vue?vue&type=script&lang=js&"
export * from "./ChangePin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e975d7",
  null
  
)

export default component.exports